/*global
    define:false
 */
define(['./resources/waypoints'], function() {
});
